import { camelCase } from 'lodash';

function isPlainObject(value: unknown): value is Record<string, unknown> {
	return Object.prototype.toString.call(value) === '[object Object]';
}

export function normalizeKeysToCamelCase<T>(value: T): T {
	if (value === null || value === undefined) {
		return value;
	}

	if (Array.isArray(value)) {
		return value.map(item => normalizeKeysToCamelCase(item)) as T;
	}

	if (value instanceof Date) {
		return value;
	}

	if (!isPlainObject(value)) {
		return value;
	}

	return Object.entries(value).reduce((acc, [key, nestedValue]) => {
		acc[camelCase(key)] = normalizeKeysToCamelCase(nestedValue);
		return acc;
	}, {} as Record<string, unknown>) as T;
}
